import React, { Component } from 'react';
import CalendarIcon from '@assets/icons/calendar-icon.svg';
import redAlertIcon from '@assets/icons/redAlert-icon.svg';
import DatePicker from 'react-datepicker';
import Grid from '@mui/material/Grid2'

class DatePickerFielder extends Component {
	updateDateInit = (dateSelected) => {
		this.props.updateDateInit(dateSelected);
	};

	updateDateEnd = (dateSelected) => {
		this.props.updateDateEnd(dateSelected);
	};

	render() {
		return (
			<Grid container style={{ border: 'solid 1px #e8e8e8d0 !important', borderRadius: '12px' }}>
				<Grid size={1}>
					<img src={CalendarIcon} className='icon my-2' alt='' />
				</Grid>
				<Grid size={11}>
					<DatePicker
						id={this.props.id}
						selected={this.props.selected}
						onChange={this.props.handleDate}
						minDate={this.props.minDate}
						timeFormat={this.props.timeFormat}
						showTimeSelect
						showMonthDropdown
						showYearDropdow
						minTime={this.props.minTime}
						maxTime={this.props.maxTime}
						dateFormat={this.props.dateFormat}
						timeIntervals={this.props.timeIntervals}
						className={this.props.classNamePicker}
						readOnly={this.props.readOnly}
					/>
					<img src={redAlertIcon} alt='' id={this.props.imgId} className={this.props.classNameImg}></img>
				</Grid>
			</Grid>
		);
	}
}

export default DatePickerFielder;
